:root {
  --object-menu-header-height-current: 85px;
  --object-menu-header-height: 103px;
}

.whiteboardContainer {
  /* The container controls the size of the whiteboard - just fill the container. */
  width: 100%;
  height: 100%;
  display: flex;
}

.whiteboard {
  flex: 1;
  position: relative;
  overflow: hidden;

  /**
   * This renders the canvas background behind any external content.
   */
  background-color: var(--theme-tertiary-background);

  outline: none;
}

.whiteboard canvas {
  width: 100%;
  height: 100%;
}

.canvasWrapper {
  width: 100%;
  height: 100%;
}

.whiteboardEmptyState {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  user-select: none;
  color: var(--aha-gray-600);
}

.whiteboardEmptyState img {
  padding-bottom: 15px;
}

.cursors {
  overflow: visible;
}
.cursor {
  position: absolute;
}
.cursor .cursorPointer {
  position: absolute;
  top: -3px;
  left: -5px;
}
.cursor .cursorName {
  pointer-events: none;
  font-family: sans-serif;
  font-size: 11px;
  height: 20px;
  line-height: 20px;
  border-radius: 13px;
  padding: 2px 4px;
  padding-right: 10px;
  white-space: nowrap;
  position: absolute;
  left: 7px;
  top: 11px;
  border: 1px solid white;
  box-shadow: 0px 2px 4px 0px #00000026;
  transition: opacity 1s ease-in-out;
  opacity: 1;
  /* Don't use themed color, since the cursor boxes don't have dark mode background */
  color: var(--aha-gray-900);
}
.cursor .cursorHideName {
  opacity: 0;
}

.cursorAvatar {
  margin-left: -2px;
  margin-top: -1px;
  margin-right: 5px;
}

.toolbarCommon {
  position: absolute;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.08);
  background-color: var(--theme-button);
  border-radius: 4px;
  text-align: center;
  display: flex;
  align-items: stretch;
  padding: 2px;
  z-index: 10;
}
.toolbarSpill:before,
.toolbarSpill:after {
  content: '';
  position: absolute;
  left: 0;
  width: 100%;

  /* should match SPACER value in HoveredLinkPopup */
  height: 8px;
}
.toolbarSpill:before {
  bottom: 100%;
}
.toolbarSpill:after {
  top: 100%;
}

.toolbarFade {
  transition: opacity 0.2s;
}
.toolbarFade * {
  pointer-events: none;
}
.toolbarFade:hover {
  opacity: 0.7;
}

.stylusToolbar {
  flex-direction: column;
  align-items: center;
  top: 50%;
  transform: translate(0, -50%);
  left: 10px;
}

.objectToolbar {
  flex-direction: row;
}

.linkPopup {
  font-size: 14px;
  padding: 10px;
}

.baselineToolbarContainer {
  margin-bottom: 10px;
  display: flex;
  pointer-events: auto;
  padding-right: 40px;
}

.baselineToolbarContainer.aiAssistantVisible {
  position: absolute;
  width: 100%;
  align-items: end;
}

/* The chat icon is 37px wide with a 25px margin on the right - so we must move over 87px */
.baselineToolbarContainer.zendeskIconVisible {
  margin-right: 87px;
}

.assistantToolbarContainer {
  display: flex;
  justify-content: center;
  flex: 1;
}

.assistantToolbar {
  position: relative;
  max-width: 500px;
  flex: 1;
  align-items: center;
  margin-left: 80px;
  margin-right: 40px;
  padding: var(--spacer-1) var(--spacer-2);
  gap: var(--spacer-2);

  input {
    flex: 1;
    appearance: none;
    border: none;
    outline: none;
    height: 34px;
  }

  input:disabled {
    background-color: inherit;
  }
}

.commentsToolbar,
.undoRedoToolbar {
  position: relative !important;
  flex-direction: row;
  justify-content: space-between;
  margin-right: 10px;
}

.zoomToolbar {
  position: relative !important;
  flex-direction: row;
  justify-content: space-between;
}

.overlayToolbar {
  position: absolute;
  left: 64px;
  right: 64px;
  top: 64px;
  bottom: 64px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  pointer-events: none;
  > * {
    pointer-events: auto;
  }
}

.toolButton.overlayToolbarButton {
  width: auto;
  padding: var(--spacer-1) var(--spacer-3);
  box-shadow: var(--theme-shadow-shallow);
  gap: var(--spacer-2);
}

.toolbarRow {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: stretch;
  color: var(--theme-primary-text);
}
.toolbarRowAlignLeft {
  justify-content: start;
}

.toolbarColumn {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  align-items: stretch;
}

.toolbarArea {
  display: flex;
  flex-direction: row;
  gap: var(--spacer-2);
  height: 34px;
  margin: 3px;
  justify-content: space-between;
  align-items: center;
}

.toolButton {
  /* Note, this class is applied with various others, e.g. labeledToolButton,
     wideToolButton that partially override but depend on it */
  width: 34px;
  height: 34px;
  margin: 3px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: var(--theme-primary-text);
  cursor: pointer;
  background-color: var(--theme-button);
}

.toolButtonWithSideLabel {
  display: flex;
  gap: var(--spacer-2);
  padding: 0 var(--spacer-2) 0 6px;
  width: auto;
  font-size: 12px;
}
.toolButtonSideLabel {
  font-size: 11px;
  opacity: 0.8;
  margin: 0;
}

.toolButton :global(.toolbar-button-background-fill) {
  fill: var(--theme-button);
}
.toolButton--stamp {
  width: 49px;
  height: 49px;
  box-sizing: border-box;
  padding: 2.5px;
}
:global(.dark-mode-allowed[data-theme='dark'])
  .toolButton
  :global(.toolbar-button-light-stroke) {
  stroke: #999999;
}

.toolButton:hover:not(.toolButtonDisabled) {
  background-color: var(--theme-button-hovered);
}

.toolButton.toolButtonActive {
  color: var(--theme-link-text-dark);
  background-color: var(--theme-list-item-active-background);
}

.toolButton.toolButtonLocked {
  background-color: var(--aha-blue-200);
}
.toolButton.toolButtonDisabled {
  opacity: 0.3;
}
.toolButton.toolButtonWide {
  width: inherit;
  padding: 0px 4px;
}

.toolButton.toolButtonHasHoverMenu {
  position: relative;
}

.toolButton .toolButtonHoverMenu {
  position: absolute;
  top: 0px;
  left: 31px;
  display: none;
}

.toolButton.toolButtonHasHoverMenu:hover {
  .toolButtonHoverMenu {
    display: block;
  }
}

.toolButtonWideContent {
  display: flex;
  align-items: center;
  padding-top: 2px;
}

.toolButtonWideContent span {
  margin-right: 2px;
  width: 16px;
  height: 16px;
}

.toolButtonWideContent span i {
  width: inherit;
  height: inherit;
}

.toolButtonWideContent span i svg {
  width: inherit;
  height: inherit;
}

.toolButtonConfig {
  padding: 0px 6px;
  justify-content: space-between;
}

.toolButtonConfigText {
  display: flex;
  align-items: center;
  flex: 1;
  font-size: 13px;
}

.toolButtonConfigTextActive {
  color: var(--theme-primary-text);
}

.toolButtonConfigText > i,
.toolButtonConfigText > aha-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-right: 8px;
}

.toolButtonConfig aha-switch {
  --aha-switch--size: 11px;
}

.toolButtonConfig aha-switch[active] {
  --aha-switch--color: var(--aha-blue-500);
}

.toolButtonWide {
  width: inherit;
  min-width: 34px;
  padding: 0px 8px;
}

.labeledToolButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 70px;
  height: 70px;
  border: 1px solid var(--theme-light-border);
  border-radius: 4px;
}

.labeledToolButtonWide {
  width: 110px;
  height: 110px;
}

.labeledToolButton:hover {
  border: 1px solid var(--theme-secondary-border);
  background-color: var(--theme-container-background);
}

.labeledToolButtonContent {
  display: flex;
  height: 100%;
  flex-direction: column;
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
}

.labeledToolButtonWide .labeledToolButtonContent {
  justify-content: space-evenly;
}

.labeledToolButtonIcon {
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 4px;
}

.labeledToolButtonIcon + span {
  flex: 1;
}

.labeledToolButtonLabel {
  color: var(--theme-tertiary-text);
  max-width: 60px;
  text-wrap: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.labeledToolButtonWide .labeledToolButtonLabel {
  max-width: 100px;
  padding-bottom: 5px;
  flex: unset;
}

.labeledToolButton:hover .labeledToolButtonLabel {
  color: var(--theme-primary-text);
}

.iconToolButton {
  width: 26px;
  height: 26px;
  padding: 8px;
}

.iconToolbarButton > svg {
  width: 24px;
  height: 24px;
}

.objectToolbar .toolButton aha-icon {
  padding-top: 1px; /* Force baseline 1px lower - this correctly aligns 18px tall icons */
}

.toolButtonWithSecondaryText {
  display: flex;
  flex-direction: column;
  align-items: start;
  font-size: 12px;
  font-weight: 500;
}

.toolButtonSecondaryText {
  font-size: 10px;
  font-weight: 400;
  color: var(--theme-secondary-text);
}

.stringToolButton {
  justify-content: start;
  width: unset;
  padding: 0 var(--spacer-2);
  font-size: 13px;
}

.iconButton {
  width: fit-content;
  justify-content: center;
  padding: 0px 7px;
  font-size: 14px;
}

.toolHDivider {
  border-right: 1px solid var(--theme-primary-border);
  margin: var(--spacer-2);
  margin-left: 2px;
  margin-right: 2px;
}

.toolbarVDivider {
  border-top: 1px solid var(--theme-primary-border);
  margin: var(--spacer-2);
  margin-top: 2px;
  margin-bottom: 2px;
}
.toolButtonBorderColor {
  border-radius: 100px;
  border-width: 5px;
  border-style: solid;
  width: 16px;
  height: 17px;
}

.toolButtonBackgroundColor {
  border-radius: 100px;
  width: 25px;
  height: 25px;
}

.sliderContent {
  flex: 0 1 auto;
  order: 0;
  align-items: center;
  width: 100%;
}

.colorSwatchContainer {
  position: relative;
}

.colorSwatchInner {
  width: 34px;
  height: 34px;
  display: flex;
  margin: 3px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 4px;
}
.colorSwatchInner.colorSwatchSelected {
  background-color: var(--aha-blue-100);
}
.colorSwatchInner:hover {
  background-color: var(--theme-list-item-hover-background);
}

.colorSwatches {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.colorSwatch {
  border-radius: 100px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: box-shadow 0.2s;
  position: relative;
}
.innerColorSwatch {
  border-radius: 100px;
  border: 2px solid var(--aha-gray-500);
  width: 14px;
  height: 14px;
}
.colorSwatchColorLeft {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  clip-path: polygon(-4px -4px, 50% -4px, 50% 150%, -4px 150%);
}
.colorSwatchColorRight {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  clip-path: polygon(40% -4px, 150% -4px, 150% 150%, 40% 150%);
}
.colorSwatchColorBackground {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: repeating-conic-gradient(#fff 0% 25%, var(--aha-gray-600) 0% 50%);
  background-size: 6px 6px;
  clip-path: circle(49% at 50% 50%);
}
/* Retina screen support */
@media only screen and (-webkit-min-device-pixel-ratio: 2),
  only screen and (min--moz-device-pixel-ratio: 2),
  only screen and (-o-min-device-pixel-ratio: 2/1),
  only screen and (min-device-pixel-ratio: 2),
  only screen and (min-resolution: 192dpi),
  only screen and (min-resolution: 2dppx) {
  .colorSwatchColorBackground {
    background-size: 5px 5px;
  }
}
/* Clip out inner circle for hollow swatch */
.colorSwatchColorBackgroundHollow:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: #fff;
  clip-path: circle(32% at 50% 50%);
}
.colorSwatchWhite.colorSwatchColorBackgroundHollow:before {
  clip-path: circle(35% at 50% 50%);
}
.colorSwatchHollow {
  border: 4px solid transparent;
  width: 14px;
  height: 14px;
}
:not(.colorSwatchHollow).colorSwatchWhite {
  border: 1px solid var(--aha-gray-200);
  width: 20px;
  height: 20px;
}

.colorSwatchHollow.colorSwatchWhite {
  box-shadow: 0 0 2px var(--aha-gray-500), 0 0 2px var(--aha-gray-500) inset;
}

.blankPattern {
  width: 18px;
  height: 18px;
  border: 2px solid var(--aha-gray-500);
  /* Diagonal line */
  background: linear-gradient(
    to top right,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0) calc(50% - 2px),
    rgb(214, 157, 157) 50%,
    rgba(0, 0, 0, 0) calc(50% + 2px),
    rgba(0, 0, 0, 0) 100%
  );
}

.colorPickerHexInput {
  margin-top: 5px;
  border: none;
  outline: none;
  color: #999;
  width: 80%;
}

aha-menu-group .menuTitle {
  padding: 6px 16px;
  text-transform: uppercase;
  color: var(--aha-gray-700);
}

aha-menu-item .menuItemWithShortcut {
  min-width: 200px;
  display: flex;
  justify-content: space-between;
}

aha-menu-item .menuItemCenterBadge aha-badge {
  align-self: auto;
}

aha-menu-item .menuItemComingSoon {
  color: var(--aha-blue-400);
  font-size: 11px;
  line-height: 16px;
}
aha-menu-item .menuItemWithShortcut .menuItemShortcut {
  color: var(--theme-tertiary-text);
}
aha-menu-item:not([disabled]):hover .menuItemShortcut {
  color: var(--theme-menu-highlighted-text);
}

.menuItemZoomLevel {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.menuItemDisabled {
  opacity: 0.3;
}

.menuItemZoomLevel > i:hover {
  color: var(--aha-gray-700);
}

.toolbarMenu,
.minimalScrollbar {
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: var(--aha-gray-500);
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: var(--aha-gray-600);
  }
}

.toolbarMenuHeading {
  color: var(--theme-tertiary-text);
  font-size: 12px;
  text-transform: uppercase;
  text-align: left;
}

.popupSectionHeading {
  font-size: 11px;
  font-weight: 400;
  color: var(--theme-tertiary-text);
  padding: 8px 11px;
  text-align: left;
}

.toolbarMenuTitle {
  padding: 8px 8px 0 8px;
  width: 100%;
}

.toolbarMenuContent {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: stretch;
}

.hintToolShortcut {
  padding: 2px 4px;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 0.2);
}

.textToolButton {
  display: flex;
  flex-direction: column;
  font-size: 12px;
}
.textToolButtonSwatch {
  width: 20px;
  height: 5px;
  margin-top: 2px;
}

.iconPickerPopup {
  height: 225px;
  overflow: hidden auto;
}

.iconPickerIcon {
  font-size: 18px;
}

.iconSvg {
  line-height: 0;
}
.iconSvg.fillContainer svg {
  width: 100%;
  height: 100%;
}

.eyedropperIconLink {
  height: 34px;
  width: 34px;
  margin: 5px 2px 0 auto;
  cursor: pointer;
  color: inherit;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.eyedropperIconLink:hover {
  background-color: var(--aha-gray-200);
  color: inherit;
}

.whiteboard .stylusToolbar :global(.tippy-content),
.whiteboard .objectToolbar :global(.tippy-content) {
  padding: 2px;
}

.whiteboard .stylusToolbar :global(.tippy-box),
.whiteboard .objectToolbar :global(.tippy-box) {
  border-radius: 4px !important;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.08) !important;
  background-color: var(--theme-button) !important;
  color: var(--theme-primary-text) !important;
}

.whiteboard aha-slider::part(tick) {
  display: none;
}

.whiteboard aha-slider::part(input) {
  --aha-slider--handle-size: 16px;
  --aha-slider--handle-color: var(--aha-blue-500);
  --aha-slider--track-color-left: var(--aha-blue-400);
  --aha-slider--track-color-right: var(--aha-blue-100);
  --aha-slider--track-height: 10px;
  --aha-slider--tick-size: 0px;
  border-radius: 25px;
  cursor: pointer;
}

/* Styles for non-collab whiteboards */
.nonCollabContainer {
  position: relative;
  width: 100%;
  height: 100%;
}

.nonCollabContainerFullscreen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9997;
}

.whiteboardActions {
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: flex;
  gap: 10px;
}

.fullscreenTopbar {
  display: flex;
  align-items: center;
  background-color: var(--theme-secondary-background);
  position: fixed;
  top: 0;
  width: 100%;
  height: 40px;
  z-index: 9999;
}

.close {
  position: absolute;
  right: 0;
  font-size: 20px;
  font-weight: bold;
  line-height: 20px;
  color: #000;
  text-shadow: 0 1px 0 #ffffff;
  opacity: 0.2;
  margin-right: 20px;
  cursor: pointer;
}

.actionButton {
  align-self: center;
  padding: 0;
  min-width: 2em;
}

/* Some basic flex helpers */
.flexRow {
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: var(--spacer-2);
}

.itemList {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: var(--spacer-2);
}

.previewAndToolbars {
  position: absolute;
  top: 0;
  width: 100%;
  right: 20px;
  z-index: 9;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 100%;
  align-items: flex-end;
  pointer-events: none;
}

.viewableCanvasArea {
  flex: 1;
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
}

.bottomToolbarContainer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 8;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
}
.presentationToolbar {
  pointer-events: all;
  display: flex;
  align-items: center;
  background-color: rgb(51, 51, 51);
  border-radius: 4px;
  padding: 2px;
  margin: 20px;
  color: rgb(181, 181, 181);
  transition: 300ms transform;
  transform: translateY(84px);
}
.presentationToolbar.presentationToolbarVisible {
  transform: translateY(0px);
}
.presentationToolbar .toolButton {
  padding: 3px;
  margin: 0;
  background-clip: content-box;
  border-radius: 7px; /* needs to take padding into account due to background-clip */
  color: rgb(181, 181, 181);
  background-color: rgb(51, 51, 51);
}
.presentationToolbar .toolButton:hover:not(.toolButtonDisabled) {
  color: #fff;
  background-color: rgb(102, 102, 102);
}
.presentationToolbar.toolButton.toolButtonActive {
  color: #fff;
  background-color: #000;
}
.presentationSlideCount {
  display: flex;
  align-items: center;
  word-spacing: 5px;
  margin: 0 8px;
}
.presentationSlideCount strong {
  color: #fff;
  font-weight: normal;
}

.presentationToolbar .toolHDivider {
  border-color: rgb(102, 102, 102);
}

/* If the side panel is enabled, we don't need the extra space on the right */
.sidePanelEnabled {
  right: 0;
}

.sidePanelOverrides {
  overflow: hidden;
}

.externalAuthModal {
  width: 500px;
  font-size: 14px;
}
.externalAuthModal aha-button:not(:last-child) {
  margin-right: var(--spacer-4);
}

.widgetsContainer {
  position: absolute;
  top: 20px;
  display: flex;
  flex-direction: column;
  gap: var(--spacer-3);
  align-items: center;
  justify-content: center;
  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
}

/* TODO: Temporary until we update ghost buttons sitewide */
.whiteboard aha-button[kind='ghost'] {
  --aha-button--color: var(--theme-primary-text);

  &:where(:not([disabled])):where(:active, [active]) {
    --aha-button--color: var(--theme-link-text-dark);
  }

  &:where(:not([disabled])):where(
      :focus-visible,
      [focused],
      :hover,
      [hovered]
    ) {
    --aha-button--background-color: var(--theme-secondary-background);
    --aha-button--border-color: transparent;
  }
}

.whiteboard aha-tooltip {
  --Tooltip__tooltip--min-width: none;
}

.stylusCustomShapeContainer {
  position: absolute;
}

.stylusCustomShapeMenu {
  position: absolute;
  display: none;
  top: -12px;
  left: 15px;
}

.stylusCustomShapeContainer:hover .stylusCustomShapeMenu {
  display: block;
}

.toolbarSubMenu {
  margin: var(--spacer-3) 0;
  overflow: hidden;
}

.draggedButton {
  position: absolute;
  z-index: 1000;
}

.whiteboardControls {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  pointer-events: auto;
}

.toolImageColorModeMenu {
  display: flex;
  margin: var(--spacer-2);
  padding: var(--spacer-1);
  align-items: center;
}

.toolImageColorModeMenu:hover {
  background-color: var(--aha-gray-200);
  cursor: pointer;
}

.toolImageColorModeMenuArrow {
  margin-left: auto;
  font-size: 10px;
}

.toolImageColorModeMenuText {
  display: flex;
  gap: var(--spacer-1);
  align-items: center;
}

.toolImageColorModePopup {
  display: flex;
  flex-direction: column;
  min-width: 120px;
}

.menuItemWithRadio {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
}

.menuItemHelpIcon {
  margin-left: 3px;
}
